import {
  IBigQueryFirestoreModel,
  IBigQueryReffable,
  ITimestampedDimension,
} from './common';

interface IBigQueryRecallSettings {
  periodInMonths: number;
}

export interface IBrandDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  name: string;
  slug: string;
  settings: {
    /**
     * Timezone is an invalid avro enum
     */
    timezone: string;
    recalls?: IBigQueryRecallSettings;
    secondaryRecalls?: IBigQueryRecallSettings;
  };
}
